var ltr6_module_trend_pages = (function (ltr6_module_trend_pages) {


    ltr6_module_trend_pages.init = function(){
      
      // tooltips

      var options = {
        intentPollInterval:20,
        followMouse:true,
        fadeInTime:0,
        fadeOutTime:0,
        popupId:'ltr6-tooltip',
        popupClass:'ltr6-tooltip',
        // openEvents:['mouseover','focus']
        // closeDelay:0
      }
      $('[data-powertip]').powerTip(options);
    };


    return ltr6_module_trend_pages;
}(ltr6_module_trend_pages || {}));